import { useCallback } from 'react';

import Tooltip from '@mui/material/Tooltip';
import DataObjectIcon from '@mui/icons-material/DataObject';
import { GridActionsCellItem } from '@mui/x-data-grid';

import { wrapExpression } from '../../utils/handlebars-expression.util';
import type { ReferencesContext_Resolver } from '../../contexts/ReferencesContext';

import type { OnSelectHandler } from './types/on-select-handler.type';

interface Props {
  readonly resolver: Readonly<ReferencesContext_Resolver>;
  readonly onSelect: OnSelectHandler;
}

export const CommandInsertionAction = ({
  resolver,
  onSelect,
}: Readonly<Props>) => {
  const handleActionClick = useCallback(() => {
    onSelect('command', wrapExpression(resolver.command));
  }, [resolver.command, onSelect]);

  const actionLabel = 'Copier le code';

  return (
    <GridActionsCellItem
      icon={
        <Tooltip title={actionLabel}>
          <DataObjectIcon />
        </Tooltip>
      }
      label={actionLabel}
      onClick={handleActionClick}
    />
  );
};
